import { combineReducers } from 'redux';
import interviewListsReducer, { InterviewListsState } from './interviewLists';

export type MenteeStoreState = {
  interviewLists: InterviewListsState;
};

const menteeReducer = combineReducers({
  interviewLists: interviewListsReducer,
});

export default menteeReducer;
